<template>
    <div class="lang arabic">
        <div class="reservation-lang">
            <div class="info">
                <h3 class="bullet01">معلومات المريض</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> الرقم التعريفي للمريض <br>
                                    ( المريض متكرر الزيارة فقط)،</div>
                                <div class="cont"><input type="text" class="input" placeholder="الرقم التعريفي للمريض"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> الاسم</div>
                                <div class="cont item2"><input type="text" class="input" placeholder="الأول الاسم"><input type="text" class="input" placeholder="الأخير الاسم"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> النوع</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  ><input type="radio" name="test01" id="test01" checked=""><span class="radio-btn"></span>
                                            <p>ذكر</p>
                                        </label>
                                        <label  ><input type="radio" name="test01" id="test02"><span class="radio-btn"></span>
                                            <p>أنثى</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>تاريخ الميلاد</div>
                                <div class="cont"><input type="text" class="input" placeholder="ex)19800320"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>الجنسية</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> اللغة</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>بلد الإقامة</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  ><input type="radio" name="test01" id="test01" checked=""><span class="radio-btn"></span>
                                            <p>كوري</p>
                                        </label>
                                        <label  ><input type="radio" name="test01" id="test02"><span class="radio-btn"></span>
                                            <p>غير ذلك</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">العنوان في البلد الأم</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>العنوان في كوريا</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>المدخلات المطلوبة رقم الهاتف</div>
                                <div class="cont">
                                    <input type="text" class="input">
                                    <!-- <p>- Please leave korean phone number or email address.</p> -->
                                </div>

                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">جهة الاتصال في حالات الطوارئ</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">الاسم</div><input type="text" class="input">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">العلاقة بالمريض</div><input type="text" class="input">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">رقم الهاتف</div><input type="text" class="input">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>معلومات التأمين</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="info">
                <h3 class="bullet01">لموعد تفاصيل</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>الأعراض <br>
                                    (سبب حجز موعد مع الطبيب)</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>الخدمات الطبية المطلوبة</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>التاريخ والوقت المفضلين</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">الأول</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="showStartDate" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply />
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }" @click.prevent="activeselect01">اختر ساعة</a>
                                                    <slide-up-down :active="select01" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 23">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select02 }" @click.prevent="activeselect02">اختر دقيقة</a>
                                                    <slide-up-down :active="select02" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 59">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">الثاني</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="showStartDate" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply />
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select03 }" @click.prevent="activeselect03">اختر ساعة</a>
                                                    <slide-up-down :active="select03" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 23">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select04 }" @click.prevent="activeselect04">اختر دقيقة</a>
                                                    <slide-up-down :active="select04" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 59">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>إرفاق تقرير طبي</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;">
                                    <label class="file">
                                        <input type="file">
                                        <div class="main-button c-gray">إرفاق ملف</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>إرفاق رابط</div>
                                <div class="cont">
                                    <input type="text" class="input">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>إرفاق صورة</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;">
                                    <label class="file">
                                        <input type="file">
                                        <div class="main-button c-gray">إرفاق ملف</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="botton-wrap">
                    <a href="" class="sub-button c-gray">تأكيد</a>
                    <a href="" class="main-button c-main">إلغاء</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import SlideUpDown from 'vue-slide-up-down';

    export default {
        components: {
            VueDatePicker,
            SlideUpDown,
        },
        data() {
            return {
                showStartDate: null, // 초기값 설정
                formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정
                select01: false,
                select02: false,
                select03: false,
                select04: false,
            };
        },
        methods: {
            activeselect01() {
                this.select01 = !this.select01;
            },
            activeselect02() {
                this.select02 = !this.select02;
            },
            activeselect03() {
                this.select03 = !this.select03;
            },
            activeselect04() {
                this.select04 = !this.select04;
            },
        },
    }
</script>